module.exports = __webpack_public_path__ + "static/media/shuttleBanner3.8764deeb.png";